import React from "react";
import styles from "./pressureTrack.module.scss";
import { fpSet, fpUpdate } from "lib/fpLodash";
import { Track } from "components/Characters/components/Track";
import { RADIO_STATES } from "./Radio";
import classnames from "classnames/bind";
import { Minus, Plus } from "lucide-react";
import { SmallStepperButton } from "./SmallStepperButton";

const classNameBuilder = classnames.bind(styles);

const PressureBubble = ({ value = 0, setValue }) => {
  return (
    <div
      className={styles["bubble-container"]}
      style={{ "--pressure": value || 0 }}
    >
      {/* <div
        className={styles["background"]}
        style={{ "--pressure": value || 0 }}
      ></div> */}
      <div className={styles["top-left-stick"]} />
      <div className={styles["left-stick"]} />
      <div className={styles["bottom-left-stick"]} />
      <div className={styles["bubble"]}>
        <div className={classNameBuilder("semisphere", "top")} />
        <div className={classNameBuilder("semisphere", "bottom")} />
        {/* <button className={styles["top"]} onClick={() => setValue(value + 1)} />
        <button
          className={styles["bottom"]}
          onClick={() => setValue(Math.max(0, value - 1))}
        /> */}
        <div className={styles["value"]}>{value}</div>
      </div>
    </div>
  );
};

export const PressureTrack = ({ value, setValue, presentation }) => {
  const pressureValue = value?.pressure || 0;
  return (
    <div className={classNameBuilder("container", { presentation })}>
      {!presentation && (
        <div className={styles["stepper-container"]}>
          <SmallStepperButton
            onClick={() =>
              setValue((prev) => fpSet("pressure", prev?.pressure + 1, prev))
            }
            disabled={pressureValue >= 3}
          >
            <Plus />
          </SmallStepperButton>
          <SmallStepperButton
            onClick={() =>
              setValue((prev) => fpSet("pressure", prev?.pressure - 1, prev))
            }
            disabled={pressureValue <= 0}
          >
            <Minus />
          </SmallStepperButton>
        </div>
      )}
      <PressureBubble
        value={value?.pressure || 0}
        setValue={(newValue) =>
          setValue((prev) => fpSet("pressure", newValue, prev))
        }
      />
      <div className={styles["bridge"]} />
      <Track
        className={styles["track"]}
        value={value?.track || []}
        setValueByIndex={(newValue, index) =>
          setValue((prev) => fpSet(["track", index], newValue, prev))
        }
        minLength={1}
        onReset={() => {
          setValue((prev) =>
            fpUpdate(["track"], (arr = []) => arr.map(() => 0), prev)
          );
        }}
        onReduce={() => {
          setValue((prev) =>
            fpUpdate(["track"], (arr = []) => arr.slice(0, -1), prev)
          );
        }}
        onIncrease={() => {
          setValue((prev) =>
            fpUpdate(
              ["track"],
              (arr = []) => [...arr, RADIO_STATES.EMPTY],
              prev
            )
          );
        }}
        alwaysVisibleUpdateButtons={!presentation}
        presentation={presentation}
        colorless
      />
    </div>
  );
};
